import React, { Component } from 'react';
import moment from 'moment';
import unescape from 'lodash/unescape';
import has from 'lodash/has';

import Icon from 'components/common/Icon';

export default class EventList extends Component {

  renderList() {
    const { events, renderItem, selectedDate, selectedEndDate } = this.props;

    const groupBy = has(this.props, 'groupBy') ? this.props.groupBy : 'day';

    let shortDateFormat;
    let longDateFormat;

    if(groupBy == 'day') {
      shortDateFormat = 'MMM D, YYYY';
      longDateFormat = 'dddd MMM D, YYYY';
    } else if(groupBy == 'week') {
      shortDateFormat = 'MMM, YYYY';
      longDateFormat = 'MMMM, YYYY';
    } else if(groupBy == 'month') {
      shortDateFormat = 'MMM, YYYY';
      longDateFormat = 'MMMM, YYYY';
    } else if(groupBy == 'year') {
      shortDateFormat = 'YYYY';
      longDateFormat = 'YYYY';
    }

    if (events.length === 0) {
      let dateString = '';

      if (selectedDate && selectedEndDate) {
        dateString = `${moment(selectedDate, 'YYYY-MM-DD').format(shortDateFormat)} - ${moment(selectedEndDate, 'YYYY-MM-DD').format(shortDateFormat)}`;
      } else if (selectedDate) {
        dateString = moment(selectedDate, 'YYYY-MM-DD').format(longDateFormat);
      }

      return (
        <div>
          <div className="list-group-header">
            {dateString}
          </div>
          <div className="list-group">
            <div className="list-item">
              <div className="inner">
                <div className="no-events">No Events</div>
              </div>
            </div>
          </div>
        </div>
      );
    }

    let prevGroup;
    let listGroupEvents = [];
    let bufferKey = 0;

    /* eslint-disable no-plusplus */
    const renderBuffer = () => (
      <div key={`listGroup${bufferKey++}`}>
        <div className="list-group-header">
          {moment(prevGroup, 'YYYY-MM-DD').format(longDateFormat)}
        </div>
        <div className="list-group">
          {listGroupEvents.map((event, key) => {
            if (listGroupEvents.length > 1 && key + 1 < listGroupEvents.length) {
              return renderItem(event, true);
            }
            return renderItem(event);
          })}
        </div>
      </div>
    );

    return (
      <div>
        {events.map((event) => {
          let toRender;

          let curGroup;
          if(groupBy == 'day') {
            curGroup = event.labels.YYYMMDD;
          } else if(groupBy == 'week') {
            curGroup = event.labels.start_moment.format('YYYY-MM');
          } else if(groupBy == 'month') {
            curGroup = event.labels.start_moment.format('YYYY-MM');
          } else if(groupBy == 'year') {
            curGroup = event.labels.start_moment.format('YYYY');
          }

          if (curGroup !== prevGroup) {
            if (prevGroup) {
              toRender = renderBuffer();
            }
            prevGroup = curGroup;
            listGroupEvents = [];
          }

          listGroupEvents.push(event);

          return toRender;
        })}
        {renderBuffer()}
      </div>
    );
  }

  render() {
    const { events, isLoading, subscribeUrl } = this.props;

    if (!Array.isArray(events) || (events.length === 0 && isLoading)) {
      // Could display a loading spinner but parent is handling this for now
      return <span />;
    }

    let subscribeUrl_out = '';

    if(subscribeUrl) {
      subscribeUrl_out = unescape(subscribeUrl);

      if(subscribeUrl_out.substr(0, 4) != 'http' && subscribeUrl_out.substr(0, 1) != '/') subscribeUrl_out = '/' + subscribeUrl_out;
    }

    return (
      <section className="full-screen-list">
        {this.renderList()}
        {subscribeUrl && (
          <a
            style={{
              fontSize: 12,
              padding: 8,
              opacity: 0.8,
            }}
            href={`${subscribeUrl_out}`}
          >
            <Icon
              icon="calendar"
              size="small"
              style={{
                marginTop: -4,
                marginRight: 4,
                display: 'inline-block',
              }}
            />
            Subscribe to this calendar
          </a>
        )}
      </section>
    );
  }
}

EventList.defaultProps = {
  isLoading: true,
};



// WEBPACK FOOTER //
// ./src/app/components/calendar/EventList.js